import React, { useState } from "react";
import { SimpleGrid, Card, Text, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import "./HelpCards.css";
import HelpCardModal from "./HelpCardModal";

// Podés reemplazar este array por datos que vengan del backend.


const HelpCards = ({ cards }) => {
   const [opened, { open, close }] = useDisclosure(false);
   const [selectedCard, setSelectedCard] = useState(null);

   const handleClick = (card) => {
      setSelectedCard(card);
      open();
   };

   if (!cards || cards.length === 0) return null;

   return (
      <div className="helpCards-container">
         <Title order={3} className="helpCards-heading">
            Tutoriales y guías

         </Title>
         <small style={{ fontSize: 'var(--fs-tiny)' }}>Hacé click en el título para ver más</small>

         <SimpleGrid
            mt={20}
            cols={{ base: 1, sm: 2, md: 3 }}
            spacing="md"
            verticalSpacing="md"
         >
            {cards.map((card) => (
               <Card
                  key={card._id}
                  shadow="sm"
                  padding="lg"
                  radius="md"
                  pos='relative'
                  mih={220}
                  withBorder
                  className="helpCards-card"
                  onClick={() => handleClick(card)}
               >
                  {card.image_url &&
                     <img  
                        className="helpCards--image"
                        src={card.image_url}
                        alt={card.title}
                       
                     />
                  }
                  <Text mt={10} styles={{
                     root: {
                        
                        zIndex: 2,
                        borderRadius:'var(--border-radius-sm)'
                     }
                  }} c='var(--color-text-primary)' px={10} fw={600} size="lg">
                     {card.title}
                  </Text>
               </Card>
            ))}
         </SimpleGrid>

         <HelpCardModal opened={opened} onClose={close} card={selectedCard} />
      </div>
   );
};

export default HelpCards;